import { Video } from '../components/types'

const profiles = {
  '16-9-640': '640x360',
  '16-9-1280': '1280x720',
  '16-9-1920': '1920x1080',
  '9-16-960': '540x960',
  '9-16-1920': '1080x1920',
  '3-2-1620': '1620x1080',
  '3-2-1080': '1080x720'
}

export function getVideo(video?: Video[]) {
  if (video && typeof window !== 'undefined') {
    if (
      window.matchMedia('(max-aspect-ratio: 1/1) and (max-width: 750px)').matches &&
      video.find(video => video.profile === profiles['9-16-960'])
    ) {
      // console.log('9-16-1920')
      return video.find(video => video.profile === profiles['9-16-960'])
    }
    if (
      window.matchMedia('(min-width: 1080px)').matches &&
      video.find(video => video.profile === profiles['3-2-1620'])
    ) {
      // console.log('3-2-1620')
      return video.find(video => video.profile === profiles['3-2-1620'])
    }
    if (
      window.matchMedia('(max-width: 1080px)').matches &&
      video.find(video => video.profile === profiles['3-2-1080'])
    ) {
      // console.log('3-2-1080')
      return video.find(video => video.profile === profiles['3-2-1080'])
    }
    // console.log('16-9-1280')
    return video.find(video => video.profile === profiles['16-9-1280'])
  }
}
